"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controls = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var copy_1 = require("../../../../copy");
var Controls = function (_a) {
    var _b;
    var loading = _a.loading;
    var _c = (0, core_1.useComponents)(), ButtonGroup = _c.ButtonGroup, PrimaryCTAButton = _c.PrimaryCTAButton;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    return (react_1.default.createElement(ButtonGroup, null,
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.PROFILE_PHONE_SAVE, properties: (_b = {},
                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                _b) },
            react_1.default.createElement(PrimaryCTAButton, { "data-testid": "update-profile", disabled: loading, type: "submit" }, copy('profile.save')))));
};
exports.Controls = Controls;
